import * as _ from 'underscore';
import * as angular from 'angular';
import { ApiServiceBase } from './api.serviceBase';

export abstract class RetailerServiceBase extends ApiServiceBase {
    static $inject = ['retailerServiceUrl', 'siteAddressUrl', 'apiCDNUrlRetailer'];
    protected readonly images: string;

    constructor(
        protected retailerServiceUrl: string,
        protected siteAddressUrl: string,
        protected apiCDNUrlRetailer: string
    ) {
        super(retailerServiceUrl, siteAddressUrl, apiCDNUrlRetailer);
    }

    auth() {
        return this.getUrl(this.authToken);
    }

    classificationCategories() {
        return this.getUrl('classificationcategories');
    }

    classificationCategoriesForInventory() {
        return this.getUrl('classificationcategories/forInventory');
    }

    classificationCategoriesForRules() {
        return this.getUrl('classificationcategories/forRules');
    }

    classificationCategoriesSearch() {
        return this.getUrl('classificationcategories/search');
    }

    getTimelineProductImageUrl(id: number, width: number, height: number) {
        if (width && height) {
            return this.getUrl('timeline/product/image/' + id + '?width=' + width + '&height=' + height);
        } else {
            return this.getUrl('timeline/product/image/' + id);
        }
    }
    country() {
        return this.getUrl('profile/country');
    }
}

angular
    .module('app.retailes.common')
    .service('commonRetailerService', RetailerServiceBase);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/services/retailer.service.ts